import TripRequestTripMatches from './trip-request-trip-matches-container';

export default TripRequestTripMatches;
